"use strict";

var _interopRequireDefault = require("/var/lib/jenkins/workspace/pay-center-front-master/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

var _echarts = _interopRequireDefault(require("@/lib/echarts"));

var _resize = _interopRequireDefault(require("./mixins/resize"));

//
//
//
//
var animationDuration = 6000;
var _default = {
  mixins: [_resize.default],
  props: {
    className: {
      type: String,
      default: "chart"
    },
    width: {
      type: String,
      default: "100%"
    },
    height: {
      type: String,
      default: "300px"
    },
    placeholder: {
      type: String,
      default: ""
    },
    labels: {
      default: []
    },
    values: {
      default: []
    },
    isPercent: {
      type: Boolean,
      default: false
    },
    barColor: {
      type: String,
      default: ""
    }
  },
  data: function data() {
    return {
      chart: null
    };
  },
  computed: {
    locale: function locale() {
      return this.$i18n.locale;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.initChart();
    });
  },
  watch: {
    locale: function locale(_locale) {
      this.initChart();
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.chart) {
      return;
    }

    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart: function initChart() {
      this.chart = _echarts.default.init(this.$el, "macarons");
      this.chart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            //滑鼠移動到chart顯示的數值
            type: "shadow" // 默认为直线，可选为：'line' | 'shadow'

          },
          //更改chart 左邊上下限的數值(min and max)
          formatter: this.isPercent ? " {a} : {c} {b}" : " {a} <br/>  {b}: {c} USD"
        },
        grid: {
          top: 11,
          left: "2%",
          right: "2%",
          bottom: "3%",
          containLabel: true
        },
        xAxis: [{
          type: "category",
          data: this.labels,
          axisTick: {
            alignWithLabel: true
          },
          axisLabel: {
            fontSize: 9.5,
            margin: 8
          }
        }],
        yAxis: {
          type: "value",
          //
          min: 0,
          // max: this.isPercent ? 100 : null,
          axisTick: {
            show: false
          },
          axisLabel: {
            // formatter: this.isPercent ? '{value}' : '{value}'
            formatter: this.isPercent
          },
          splitLine: {
            show: false
          }
        },
        series: [{
          name: this.placeholder,
          type: "bar",
          stack: "vistors",
          barWidth: "30%",
          data: this.values,
          animationDuration: animationDuration,
          itemStyle: {
            color: this.barColor
          }
        }]
      });
    }
  }
};
exports.default = _default;